export default {
    refresh_firmware_title: "Refresh the Firmware Versions",
    refresh_firmware_question: "Do you want to refresh firmware versions?",
    refresh_firmware_refresh: "Refresh",
    refresh_firmware_success_message: "The firmware versions have been refreshed",
}